import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import Dropzone from 'react-dropzone'

import Icon from 'Pods/Shared/Icon/Icon'

class AddMarmosetEmbedModal extends React.Component {
  constructor() {
    super()

    this.onDrop = this.onDrop.bind(this)
  }

  onDrop(files) {
    const onlyMarmosetFiles = files.filter(file => file.name.split('.').pop().toLowerCase() === 'mview')

    this.props.addFiles(onlyMarmosetFiles)
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.props.closeModal}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--smaller',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal">
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.props.closeModal}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--add-embed">
            <div className="l-inner-large">
              <div className="heading-20 modal-header">Add Marmoset preview</div>
              <p className="text-default u-mb10">
                Please drag & drop <span className="text-semibold">Marmoset 3D Viewer</span> file or browse files
              </p>

              <div className="dropzone-container--grey">
                <Dropzone
                  className="drop-area"
                  onDrop={this.onDrop}
                >
                  <div className="drop-area__text">
                    Drag & Drop files here or
                    <span className="btn btn-fat btn-primary u-ml10">Browse</span>
                  </div>
                  <Icon type={['fal', 'upload']} notSpaced />
                </Dropzone>
              </div>

              <div className="u-text-right u-mt10">
                <button type="button" className="btn btn-outline-default btn-fat" onClick={this.props.closeModal}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

AddMarmosetEmbedModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  addFiles: PropTypes.func.isRequired,
}

export default AddMarmosetEmbedModal
